import React from 'react';
import { useHistory } from "react-router-dom";

export const EmptyPage = () => {

    const history = useHistory();
    const handle = () => {
        history.push({ pathname: "/", state: { titulo: "objeto qualquer" } })

    };

    return (
        <div className="p-grid">
            <div className="p-col-12">
                <div className="card">
                    <h5>Empty Page</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                    <button onClick={handle}>
                        Pagina Iniciala
                    </button>
                </div>
            </div>
        </div>
    );
}
